import { Container } from "./styles";
import { Column } from "components/styles";
import SpaceDurationData from "../../components/SpaceDurationData";
import { Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import SpaceDetails from "../../RegularReservationActivity/RegularReservationView/ReservationMainView/SpaceDetails";
import SpaceFeatureData from "../../components/SpaceFeatureData";
import useCancelSpaceReservation from "../../utils/hooks/useCancelSpaceReservation";
import CancelReservationButton from "../../components/CancelReservationButton";
import DialogCancelReservation from "../../components/DialogCancelReservation";
import { RESOURCES_CONSTANTS } from "config/constants";
import ReservationState from "../../components/ReservationState";
import useSpaceReservationState from "../../RegularReservationActivity/RegularReservationView/utils/hooks/useSpaceReservationState";
import useSaveReservationInformation from "../../utils/hooks/useSaveReservationInformation";
import SpaceLocationData from "../../RegularReservationActivity/RegularReservationView/ReservationMainView/SpaceLocationData";

const reservationType = RESOURCES_CONSTANTS.RESERVATION_TYPES.MANUAL;
const AdminReservationView = ({
	updateActivityPopup, adminReservation
}) => {
	const {
		name, details, schedule,
		finalized, space
	} = adminReservation;
	const { cancelReservation, dialogCancelReservation } = useCancelSpaceReservation({
		updateActivityPopup, reservation: adminReservation,
		reservationType
	});
	const reservationState = useSpaceReservationState({
		finalized, updateActivityPopup
	});
	const saveReservationInformationHandler = useSaveReservationInformation({
		reservation: adminReservation,
		reservationType, reservationState,
		updateActivityPopup
	});
	return (
		<>
			<Container>
				<Column gap="6px">
					<Title title={name}>{name}</Title>
					<SpaceDetails details={details} />
					<SpaceDurationData schedule={schedule} />
					<SpaceLocationData space={space} />
				</Column>
				<SpaceFeatureData {...space} />
				<CancelReservationButton
					reservation={adminReservation}
					openDialogCancelReservation={dialogCancelReservation.open} />
				<ReservationState
					reservation={adminReservation}
					reservationState={reservationState}
					saveReservationInformationHandler={saveReservationInformationHandler} />
			</Container>
			<DialogCancelReservation
				dialog={dialogCancelReservation}
				cancelReservation={cancelReservation} />
		</>
	);
}

export default AdminReservationView;